import React from 'react';

//Components
import Icon from '../../Icon/Icon';

//Styles
import Styles from './ButtonWithIcon.module.scss';

//Utils
import PropTypes from 'prop-types';

const ButtonWithIcon = ({iconName, navigateHandler, children, ...props}) => {

    return (
        <button className={Styles.button} onClick={navigateHandler} {...props}>
            <div className={Styles.icon}>
                <Icon name={iconName} size={18} color='#B3BDC8'/>
            </div>
            {children}
        </button>
    );
};

ButtonWithIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

export default ButtonWithIcon
